import TablePagination from '../component/TablePagination';
import React, { useEffect, useState } from 'react';
import Layout from '../component/Layout';
import './OrderModals.css';
import { ArrowUpTrayIcon, CircleStackIcon, EllipsisVerticalIcon, PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { getSupportt, markRead } from '../adapter/api';
import jsPDF from "jspdf";
import "jspdf-autotable";

const Support = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const handlePageChange = (page) => page > 0 && page <= totalPages && setCurrentPage(page);
  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);

  // Helper Functions
  const formatDate = (date) => new Date(date).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const handleGetCustomers = async () => {
    setCustomers([]);
    const response = await getSupportt()
    setCustomers(response.data.data)
  }


  useEffect(() => {
    handleGetCustomers()
  }, []);


  // Derived states
  const filteredOrders = customers.filter((order) => {
    const search = searchTerm.toLowerCase();
    return (
      order.name?.toString().toLowerCase().includes(search) ||
      order.email?.toLowerCase().includes(search) ||
      order.phoneNumber?.toString().toLowerCase().includes(search) ||
      order.subject?.toString().toLowerCase().includes(search) ||
      order.message?.toString().toLowerCase().includes(search)
    );
  });

  // Inside the component function
  const exportToPDF = () => {
    const doc = new jsPDF();

    // Adding title to PDF
    doc.text("Messages", 20, 20);

    // Set up headers for the table
    const headers = ["#", "Name", "Email", "Phone No.", "Subject", "Message"];

    // Create rows dynamically based on orders
    const rows = paginatedOrders.map(order => [
      order.contactId,
      order.name,
      order.email,
      order.phoneNumber,
      order.subject,
      order.message
    ]);

    // Add the table to the PDF
    doc.autoTable({
      head: [headers],
      body: rows,
      startY: 30, // The Y position where the table starts
    });

    // Save the PDF to the local system
    doc.save("messages.pdf");
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };

  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );


  const handleEditItem = (index) => {
    console.log("Edit item at index:", index);
    // Implement the logic to edit the item
  };

  const handleDeleteItem = (index) => {
    console.log("Delete item at index:", index);
    // Implement the logic to delete the item
    // For example, you can update the items array:
    const updatedItems = selectedCustomer.items.filter((_, i) => i !== index);
    setSelectedCustomer({ ...selectedCustomer, items: updatedItems });
  };


  const openModal = (order) => {
    toggleDropdown(null)
    setSelectedCustomer(order); // Set the selected order to display its details
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCustomer(null); // Clear selected order when closing the modal
  };


  const handleMarkAsRead = async (rowData) => {
    toggleDropdown(null)
    const response = await markRead(rowData.contactId)
    handleGetCustomers();

  }


  return (
    <Layout>
      <h1 className="text-2xl font-medium mb-4 mt-7 font-inter text-lg">Support Messages</h1>
      {/* Page content goes here */}
      <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      <div className="data-card overflow-x-auto mt-4 rounded-lg">
        <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

          <div className="w-1/3 pb-3">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search support…" aria-label="Search support"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="npb-3 flex">

            <button onClick={exportToPDF}
              className="px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <ArrowUpTrayIcon className="h-4 w-4 mr-2 mt-0.4" />
              Export
            </button>
          </div>
        </div>
        <table className="data-table  min-w-full bg-white border-b border-r border-l border-gray-200 shadow-sm">
          <thead>
            <tr className="bg-grey border-b">
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700"></th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700"></th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Date</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Name</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Email</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Phone Number</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Subject</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Message</th>

            </tr>
          </thead>
          <tbody>
            {paginatedOrders.map((order) => (
              <tr
                key={order.contactId}
                className={`border-b hover:bg-gray-50 ${!order.read ? 'bg-lightBlue' : ''}`}
              >
                <td
                  className="px-4 py-3 text-sm text-yellow font-inter cursor-pointer"

                >
                  <EllipsisVerticalIcon className="h-5 w-5 mr-2"
                    onClick={() => toggleDropdown(order.contactId)} />
                  {dropdownOpenId === order.contactId && (
                    <div className="absolute bg-white shadow rounded p-2" style={{ width: "10%" }}>
                      <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={() => handleMarkAsRead(order)}>Mark as Read</button>
                      <hr className="w-full border-gray-200 my-2" />
                      <button className="block w-full text-left px-2 py-1 text-red-600 hover:text-yellow text-gray-700" onClick={() => openModal(order)}>View</button>
                    </div>
                  )}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{!order.read && <div
                  style={{
                    width: '10px',  // Set the width
                    height: '10px', // Set the height
                    borderRadius: '50%', // Make it a circle
                  }} className='bg-blue'
                />}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{formatDate(order.date)}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.name}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.email}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.phoneNumber}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.subject}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.message}</td>


              </tr>
            ))}

          </tbody>
        </table>
        {/* Pagination */}
        <div className="data-pagination bg-grey mb-0 w-full flex justify-between border-t border-l pl-3 border-r pr-3 pt-3 items-center md:flex-row justify-between pt-4">
          <span className="text-sm font-medium">
            Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
            {filteredOrders.length}
          </span>
          <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
      <div className="data-endcap">


        {/* Modal */}
        {isModalOpen && selectedCustomer && (
        <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="order-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-lg font-semibold mb-4">Message Details</h2>
              <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

              {/* Other Order Details */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  defaultValue={selectedCustomer.name}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  defaultValue={selectedCustomer.email}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  defaultValue={selectedCustomer.phoneNumber}
                />
                <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  defaultValue={selectedCustomer.subject}
                />
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  defaultValue={selectedCustomer.message}
                />


              </div>





              <div className="flex justify-center space-x-2">

                <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm  rounded-lg hover:bg-yellow hover:text-white hover:border-white"
                  onClick={closeModal}>
                  CLOSE
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </Layout>
  );
};

export default Support;
